import React, { FC } from 'react';

import { Gradient } from '../../config/designSystem/Colors';
import { GradientView } from '../Gradients/GradientView';
import { SPACING } from '../../config/designSystem/Spacing';
import { Title1 } from '../../config/designSystem/typography';

interface ExerciseIllustrationProps {
  /** the exercise's icon (figma variant: Exercise / Shape) */
  emoji?: string;
  /** module gradient for the tile background */
  gradient: Gradient;
  size?: number;
}

/**
 * figma: ❖ Exercise Illustration (Activities & Challenges pt1)
 * The rounded illustration tile shown on memo cards and activity screens.
 */
export const ExerciseIllustration: FC<ExerciseIllustrationProps> = ({
  emoji,
  gradient,
  size = 104,
}) => {
  return (
    <GradientView
      gradient={gradient}
      style={{
        width: size,
        height: size,
        borderRadius: SPACING['sp-16'],
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Title1>{emoji || '✨'}</Title1>
    </GradientView>
  );
};
